
import {Vue, Component, Emit, Prop} from 'vue-property-decorator';

import {accountApi} from '@/api';
import formHelper from '../../../js/classes/classes.helper';
@Component
export default class Class_Teacher extends Vue {
    @Prop({
        default() {
            return [];
        }
    })
    private teacherList?: any;
    @Emit('closeModal') private closeModal() {}
    // 关联课程时
    @Emit('refreshCourseList') private refreshCourseList() {}
    //===================================data区域begin
    teacherLoading: boolean = false;
    schoolId: string = '';
    // 关联授课教师列表
    columnsTeacher: any = formHelper.courseTeacherColumns;
    pagerTeacher: any = {
        default: {
            pagesize: 200,
            pagenum: 1,
            total: 0,
            rows: []
        }
    };
    courseTeacher: any = [
        {
            courseName: '',
            courseId: '',
            classId: '',
            teacherId: ''
        }
    ];
    //===================================data区域end
    //===================================computed区域begin
    //===================================computed区域end
    //===================================methods区域begin
    // 教师本地搜素
    filterOption(input: any, option: any) {
        return (
            option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0 ||
            option.key.toLowerCase().indexOf(input.toLowerCase()) >= 0
        );
    }

    // 获取教师列表
    getTeacherList() {
        let me = this;
        me.teacherLoading = true;
        let urlQueryParmas = {
            role: 'teacher', //角色为老师
            schoolId: me.schoolId //当前登录人员所属的学校老师accountApi.getList({
        };
        accountApi.getList({
            context: me,
            pager: me.pagerTeacher.default,
            urlQueryParmas: urlQueryParmas,
            afterRender(data: any) {
                me.teacherLoading = false;
                return data;
            }
        });
    }
    refreshTeacher() {
        this.getTeacherList();
    }
    selectTeacher(val: any, record: any) {
        // console.log(val, record);
        this.courseTeacher[record.index].teacherId = val;
    }
    handleOk() {
        // console.log(this.courseTeacher);
        let judgeTeacherId = true;
        this.courseTeacher.forEach((el: any) => {
            if (el.teacherId != undefined) {
                judgeTeacherId = false;
            }
        });
        if (judgeTeacherId) {
            this.$message.warning('请选择教师！');
            return;
        }
        let me = this;
        let data: any = {
            addClassCourses: []
        };
        let form = JSON.parse(JSON.stringify(this.courseTeacher));
        // 将未选择关联教师的数据去除
        for (let i = 0; i < form.length; i++) {
            delete form[i].courseName;
            delete form[i].index;
            if (form[i].teacherId == undefined) {
                form.splice(i, 1);
            }
        }
        data.addClassCourses = form;
        // console.log(data.addClassCourses);
        accountApi.authorizeTeacher({
            context: me,
            data: data,
            success(data: any, parameters: any) {
                me.$message.success('恭喜你，操作成功！');
                me.$emit('refreshCourseList');
                me.$emit('closeModal');
                me.$emit('refreshClassList');
            },
            error(error: any, message: string, parameters: any) {
                me.$message.error(message);
            }
        });
    }
    handleCancel() {
        let me = this;
        if (!me.courseTeacher[0].teacherId) {
            me.$emit('closeModal');
            return;
        }
        me.$confirm({
            title: '提示',
            content: '取消后编辑内容不会保存，请谨慎操作',
            onOk() {
                me.$emit('closeModal');
            },
            onCancel() {}
        });
    }
    // 跳转师生管理页面
    jumpAccountManage() {
        let routeUrl = this.$router.resolve({
            path: '/school/account/account_center'
        });
        window.open(routeUrl.href, 'account_center');
    }
    //===================================methods区域end
    created() {
        // console.log(this.teacherList);
        let state = this.$app.getState();
        this.schoolId = state.schoolId;
        if (this.teacherList && !this.teacherList[0].course) {
            this.courseTeacher[0].courseName = this.teacherList[0].courseName;
            this.courseTeacher[0].courseId = this.teacherList[0].courseId;
            this.courseTeacher[0].classId = this.teacherList[0].classId;
            this.courseTeacher[0].index = 0;
        }
        if (this.teacherList[0].course) {
            let courseData: any = [];
            let dataList = this.teacherList[0].course;
            for (let i = 0; i < dataList.length; i++) {
                courseData.push({});
                courseData[i].courseName = dataList[i].course.name;
                courseData[i].courseId = dataList[i].course.courseId;
                courseData[i].classId = this.teacherList[0].classId;
                courseData[i].index = i;
            }
            this.courseTeacher = courseData;
            // console.log(this.courseTeacher);
        }
        // console.log(this);

        this.getTeacherList();
    }
}
